import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getSupplierOrder, deleteSupplierOrder } from '../actions/SupplierOrderActions';
import { Pane, Heading, Button } from 'evergreen-ui';

import DeleteDialog from '../../common/DeleteDialog/DeleteDialog';
import { Link } from 'react-router-dom';
import SupplierOrderInfoBlock from '../components/SupplierOrderInfoBlock';

class ViewSupplierOrder extends Component {
    constructor(props) {
        super(props);

        this.id = this.props.params.id;
    }
    
    async componentDidMount() {
        await this.props.dispatch(getSupplierOrder(this.id))
    }

    handleDelete = () => {
        this.props.dispatch(deleteSupplierOrder(this.id));
    }

    render() {
            
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/supplier-orders">
                            <Button iconBefore="arrow-left">
                                Inapoi la lista comenzi furnizor
                            </Button>
                        </Link>
                    </Pane>
                    
                    <Pane marginLeft={16} alignSelf="flex-end">
                        <DeleteDialog
                            onDelete={this.handleDelete}
                            buttonLabel="Sterge comanda furnizor"
                            title="Confirmare stergere comanda furnizor"
                            confirmLabel="Sterg definitiv comanda furnizor"
                            message="Esti sigur ca vrei sa stergi comanda furnizor?"/>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Comanda Furnizor - <strong>{this.props.supplierOrder.nirNumber}</strong>
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <SupplierOrderInfoBlock supplierOrder={this.props.supplierOrder}/>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        supplierOrder: state.supplierOrders.current
    }
}

export default connect(mapStateToProps)(ViewSupplierOrder);